
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
        activeLoadPreviousPage: true,
      	showMobileLoading: true,
      	enableOTP: true,
        enableKeepScrollbackPosition: true,
        //paginationType: 'default'
	},
    selector: {
    	otpButtons: '.ProductItem__ImageWrapper'
  }
};

(function() {
	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

        // Add custom Boost153578
        // Start custom Boost215940 
        let isCustomizable = true;
        if (data.tags.includes('Non-Customizable') || data.tags.includes('SMPLS')) {
          isCustomizable = false;
        }
        // End custom Boost215940 
          
          if(isCustomizable){
        itemHtml = itemHtml.replace(/{{itemCustom}}/g, '<p class="cust modal-toggle" id="mybBtn">🪡 Customizable</p>');
          }

		//Add class
		itemHtml = itemHtml.replace(/{{mobileRow}}/g, boostPFSConfig.custom.mobile_items_per_row);
		itemHtml = itemHtml.replace(/{{tabletRow}}/g, boostPFSConfig.custom.tablet_items_per_row);
		itemHtml = itemHtml.replace(/{{desktopRow}}/g, boostPFSConfig.custom.desktop_items_per_row);

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));

		// Add Reviews
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
		itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
		itemHtml = itemHtml.replace(/{{buildButtonSecond}}/g, buildButtonSecond());
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if (typeof Utils.compileShopifyProductVariables == 'function') {
			itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
		}

		if (typeof Utils.compileShopifyProductMetafield == 'function') {
			itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
		}
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/ 
	function buildClass() {
		return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
	}

	function buildClassHiz() {
		return boostPFSThemeConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
	}

	function buildButtonSecond() {
		return boostPFSThemeConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSThemeConfig.label.view_product + '</a>' : '';
	}

	function buildImage(data, images) {
		var htmlImg = '';
		if (!images) images = [];
		if (images.length == 0){
			images.push({
				src: boostPFSConfig.general.no_image_url,
				id: data.id,
				width: 480,
				height: 480
			});
		}
		if (images.length > 0) {
			htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
			var use_natural_size = false;
			var has_alternate_image = false;
			if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
				use_natural_size = true;
			}
			if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
				has_alternate_image = true;
			}
			if (has_alternate_image) {
				htmlImg += 'ProductItem__ImageWrapper--withAlternateImage ';
			}
          	for (var i = 0; i < data.tags.length; i++) {
            if (data.tags[i].includes('Lower Size')) {
              htmlImg += 'losz';
              break;
            } else if (data.tags[i].includes('Upper Size')) {
              htmlImg += 'upsz';
              break;
            } else if (data.tags[i].includes('Coord_Size')) {
              htmlImg += 'losz';
              break;
            }
          }
			htmlImg += '">';
			
			var max_width = images[0].width;
			if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
			var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
			htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
			var aspect_ratio = images[0].width / images[0].height;
			if (use_natural_size) {
				htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
			}
			htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';
			
			if (has_alternate_image && images.length > 1) {
				var sizes = '200,300,400,600,800,900,1000,1200';
				var support_size = imageSize(sizes, images[1]);
				var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
				htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad" data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
			}
			
			var sizes_main = '200,400,600,700,800,900,1000,1200';
			var support_size = imageSize(sizes_main, images[0]);
			var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '{width}x') : boostPFSConfig.general.no_image_url;
			htmlImg += '<img class="ProductItem__Image Image--lazyLoad" data-src="' + thumbUrl_main + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
			htmlImg += '<span class="Image__Loader"></span>';
			htmlImg += '<noscript>';
			htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '<img class="ProductItem__Image" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '</noscript>';
			htmlImg += '</div>';
			htmlImg += '</a>';
		}
		return htmlImg;
	}

	function imageSize(sizes, image) {
		if (image) {
			var desired_sizes = sizes.split(',');
			var supported_sizes = '';
			for (var k = 0; k < desired_sizes.length; k++) {
				var size = desired_sizes[k];
				var size_as_int = size * 1;
				if (image.width < size_as_int) { break; }
				supported_sizes = supported_sizes + size + ',';
			}
			
			if (supported_sizes == '') supported_sizes = image.width;
			
			if(!jQ.isNumeric(supported_sizes)) {
				supported_sizes = supported_sizes.split(',').join(',');
				supported_sizes = supported_sizes.substring(0,supported_sizes.lastIndexOf(','));
			}
			return supported_sizes;
		} else {
			return '';
		}
	}
  
    function buildReview(data) {
      // Build Labels
      var  html = '';
      if (Utils.getProductMetafield(data, 'judgeme', 'badge') !== null) {
        html = "<div style='text-align: center;' class='jdgm-widget jdgm-preview-badge' data-id='" + data.id + "'>" + Utils.getProductMetafield(data, 'judgeme', 'badge').replace(/\|/g, '"') + "</div>";
      }
      return html;
    }

	function buildPrice(data) {
		var html = '';
		var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
		var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
		html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
		if (onSale) {
			html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span> ';
			html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
		} else {
			if (priceVaries) {
				// html += '<span class="ProductItem__Price Price Text--subdued">' + boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)) + '</span>';
				// html += '<span class="ProductItem__Price Price Text--subdued">' + 'from' + Utils.formatMoney(data.price_min) + '</span>';
				html += '<span class="ProductItem__Price Price Text--subdued">' + Utils.formatMoney(data.price_min) + '</span>';
			} else {
				html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span>';
			}
		}
		html += '</div>';
		return html;
	}

	function buildLabels(data) {
		var html = '';
		var product_labels = '';
        /*
        for (var tag of data.tags) {
          if (tag == '1 Set of 2') {
        	html += '<div class="label_icon label_icon-mob azfr">Set of 2</div>';
            break;
          }
          
          if (tag == '1 Set of 3') {
    		html += '<div class="label_icon label_icon-mob azfr">Set of 3</div>';
            break;
          }
    	  
          if (tag == '1 Set of 4') {
    		html += '<div class="label_icon label_icon-mob azfr">Set of 4</div>';
            break;
          }
          
          if (tag == 'a Quilted_Cotton') {
    		html += '<div class="label_icon label_icon-mob quil">Quilted Cotton</div>';
            break;
          }
    	
          if (tag == 'b Convertible') {
        	html += '<div class="label_icon label_icon-mob conv">Convertible</div>';
            break; 
          }
          
          if (tag == 'c Reversible') {
    		html += '<div class="label_icon label_icon-mob revr">Reversible</div>';
            break;
          }
          
          if (tag == 'd Handspun_Handwoven') {
        	html += '<div class="label_icon label_icon-mob">Handspun Handwoven</div>';
            break;
          }
          
          if (tag == 'e Vegetable_Dyed') {
    		html += '<div class="label_icon label_icon-mob veg">Vegetable Dyed</div>';
            break;
          }
          
          if (tag == 'f Handwoven') {
            html += '<div class="label_icon label_icon-mob vown">Handwoven</div>';
            break;
          }
    	
          if (tag == 'g Organic_Cotton') {
    		html += '<div class="label_icon label_icon-mob orgc">Organic Cotton</div>';
            break;            
          }
          
          if (tag == 'h Natural_Dyed') {
    		html += '<div class="label_icon label_icon-mob orgc">Natural Dyed</div>';
            break;
          }
          
          if (tag == 'i Azo_Free') {
    		html += '<div class="label_icon label_icon-mob azfr">Azo-Free</div>';
            break;
          }
          
          if (tag == 'j Ikat') {
    		html += '<div class="label_icon label_icon-mob ikt">Ikat</div>';
            break;
          }
          
          if (tag == 'k Hand_Tie_Dyed') {
    		html += '<div class="label_icon label_icon-mob orgc">Hand<br>Tie-Dyed</div>';
            break;
          }
          
          if (tag == 'l Hand_Embroidered') {
    		html += '<div class="label_icon label_icon-mob">Hand Embroidered</div>';
            break;
          }
          
          if (tag == 'm Hand_Finished') {
        	html += '<div class="label_icon label_icon-mob orgc">Hand Finished</div>';
            break;
          }
          
          if (tag == 'n Hand_Block_Printed') {
        	html += '<div class="label_icon label_icon-mob">Hand Block Printed</div>';
            break;
          }
          
          if (tag == 'o Wrap_Around') {
        	html += '<div class="label_icon label_icon-mob wpar">Wrap Around</div>';
            break;
          }
          
          if (tag == 'q Cotton Flax') {
        	html += '<div class="label_icon label_icon-mob orgc">Cotton Flax</div>';
            break;
          }
          
          if (tag == 'r Cotton Corduroy') {
        	html += '<div class="label_icon label_icon-mob">Cotton Corduroy</div>';
            break;
          }
          
          if (tag == 's Cotton Flannel') {
        	html += '<div class="label_icon label_icon-mob orgc">Cotton Flannel</div>';
            break;
          }
          
          if (tag == 'sa Cotton Denim') {
        	html += '<div class="label_icon label_icon-mob orgc">Cotton Denim</div>';
            break;
          }
          
          if (tag == 't 100% Cotton') {
        	html += '<div class="label_icon label_icon-mob orgc">100% Cotton</div>';
            break;
          }

          if (tag == 'Primary Fabric_100% Cotton Velvet') {
        	html += '<div class="label_icon label_icon-mob orgc">Cotton Velvet</div>';
            break;
          }
          if (tag == 'Primary Fabric_100% Linen') {
        	html += '<div class="label_icon label_icon-mob orgc">100% Linen</div>';
            break;
          }
          if (tag == 'Primary Fabric_100% Cotton Waffle') {
        	html += '<div class="label_icon label_icon-mob orgc">Cotton Waffle</div>';
            break;
          }
          if (tag == 'Primary Fabric_100% Cotton Chanderi') {
        	html += '<div class="label_icon label_icon-mob orgc">Cotton Chanderi</div>';
            break;
          }
          if (tag == 'Primary Fabric_100% Cotton Denim') {
        	html += '<div class="label_icon label_icon-mob orgc">Cotton Denim</div>';
            break;
          }
          
        }
        */
		if (boostPFSThemeConfig.custom.show_labels) {
			product_labels = '';
			var tags = data.tags;
			for (var k = 0; k < tags.length; k++) {
				var tag = tags[k];
				if (tag.indexOf('__label') != -1) {
				product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
				break;
				}
			}
			if (!soldOut) {
				if (onSale)
					product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sale + '</span>';
			} else {
				product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sold_out + '</span>';
			}
			
			if (product_labels != '') {
				html += '<div class="ProductItem__LabelList">';
				html += product_labels;
				html += '</div>';
			}
		}

        let metaSticker = Utils.getProductMetafield(data , 'custom' , 'plp_sticker');
        if(metaSticker !== null){
          html += '<div class="label_icon label_icon-mob '+ Utils.slugify(metaSticker) +'">'+ metaSticker +'</div>';
        }
      
		return html;
	}

	function buildInfo(data, indx) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_product_info) {
			var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
			html += '<div class="ProductItem__Info ' + infoClass + ' ">';
			if (boostPFSThemeConfig.custom.show_vendor) {
				html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
			}

			html += '<div class="info-title"><h2 class="ProductItem__Title Heading">';
			html += '<a href="{{itemUrl}}">' + data.title + '</a>';
          	html += '{{itemReviews}}';
			html += '</h2>'; 
          
            html += '<div class="boost-pfs-custom-container">';
    			html += buildPrice(data);
    			if (boostPFSThemeConfig.custom.show_color_swatch) {
    				html += buildSwatch(data, indx);	
    			}

          let isCustomizable = !data.tags.includes('Non-Customizable')
          console.log(isCustomizable)
          
          if(isCustomizable){
                html += '<p class="cust modal-toggle" id="mybBtn">🪡 Customizable</p>'
          }
            html += '</div></div>';
			html += '</div>';
		}

		return html;
	}

	function buildSwatch(data, indx) {
		var itemSwatchHtml = '';
		if (boostPFSThemeConfig.custom.show_color_swatch) {
		var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;
		data.options_with_values.forEach(function (option, index) {
			var option_name = option.name.toLowerCase();
			if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
			var values = '';
			itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
			var i = 0;
			data.variants.forEach(function (variant) {
				var temp = variant.merged_options.filter(function (obj) {
					obj = obj.toLowerCase();
					if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1)
						return obj;
				});
				temp = temp[0].split(':');

				var value = temp[1].toLowerCase();
				if (values.indexOf(value) == -1) {
					values = values + ',' + value;
					values = values.split(',');
					var size = '200,400,600,700,800,900,1000,1200';
					var supported_sizes = imageSize(size, variant.image);
					var color_image = Utils.optimizeImage(variant.image);
					var name_color = Utils.slugify(value) + '.png';
					var checked = (i == 0) ? 'checked=checked' : '';
					var imageInfo = null;
					var image_aspect_ratio = 1;
					imageInfo = data.images_info.find(function (imageOb) {
						if (imageOb.src == variant.image){
							image_aspect_ratio = imageOb.width / imageOb.height;
						return imageOb;
						} 
					});
					if (!imageInfo){
						if (data.images_info.length > 0){
							imageInfo = data.images_info[0];
						} else {
							imageInfo = {
							src: boostPFSConfig.general.no_image_url,
								id: variant.id,
								width: 480,
								height: 480
							}
						}
						
					}
					var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
					var color_input_id = color_name + "-" + values.length;
					var variant_price = variant.price ? variant.price : 0;
					var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
					var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
					itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
					itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' +  imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
					itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
					itemSwatchHtml += '</div>';
					i++;
				}
			});
			itemSwatchHtml += '</div>';
			}
		});
		}
		return itemSwatchHtml;
	}
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
					sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var topSortingSelector = jQ(Selector.topSorting);
		topSortingSelector.find('.Popover__Value').click(function(e) {
			FilterApi.setParam('sort', jQ(this).data('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
			jQ('.CollectionToolbar__Item--sort').trigger('click');
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
		});
	}
	/************************** END BUILD TOOLBAR **************************/
    FilterOptionItem.prototype.onClick = function(event) {
      if (event) {
        event.preventDefault();
      }
      if (!this.isDisabled()) {
        if (this.requestInstantly || this.parent.filterType == FilterOptionEnum.FilterType.COLLECTION) {
          this.onApplyFilter();
        } else {
          this.onSelectFilter();
        }
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
      }
    }
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		/**
		 *  Call theme function 
		 *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
		 *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
		 *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
		
		if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
		bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
		bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
		}  
		*/

		// Fix image not load on Instagram browser - initialize swatch image
		jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function() {
			jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
			jQ(this).addClass('active');
			var parent = jQ(this).parent();
			var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
			var variantInfo = parent.find('input.ColorSwatch__Radio');
			productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
			productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
			productImage.find('img.ProductItem__Image').hide();
			productImage.attr('href', variantInfo.data('variant-url'));
			var variantPrice = '';
			if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')){
				variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
				variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
			} else {
				variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
			}
			jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
		})

		//Change view layout
		var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
		if (desktopView && desktopView != parseInt(boostPFSThemeConfig.custom.desktop_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass());
			jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
		}
		var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
		if (mobileView && mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/'+ boostPFSThemeConfig.custom.mobile_row + '--phone');
			jQ(Selector.products + ' .Grid__Cell').addClass('1/'+ mobileView + '--phone');
		}

      jQ('.modal-toggle').on('click', function(e) {
  e.preventDefault();
  jQ('.modalin').toggleClass('is-visible');
  jQ('#jsscri').css('overflow','hidden');
});
  jQ('.close').on('click', function(e) {
  e.preventDefault();
  jQ('.modalin').removeClass('is-visible');
    jQ('#jsscri').css('overflow','auto');
});
      
	};

	// Build Default layout
	// Filter.prototype.errorFilterCallback = function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};
  
    /* start-boost-custom */
    document.addEventListener("DOMContentLoaded", function(event) { 
      window.scrollTo(0, 0);
    });
  
	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
      
        /* #boost-79245: Theme upgrade */
		var from = Globals.queryParams.page == 1 ? Globals.queryParams.page : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
        var to = from + data.products.length - 1;
        var totalProduct = 'Showing ' + to + ' of ' + data.total_product + ' products';  
        var totalProductSelector = jQ('.boost-pfs-filter-total-product');      
      
      	// adjust the timeout delay if needed
    	// if (eventType === 'init') setTimeout(function() {window.scrollTo(0, 0);}, 100);

        if (Utils.checkExistFilterOptionParam()) {
          jQ('.boost-pfs-clear-button-mobile').html('<a href="javascript:;" aria-label="Clear All" class="bc-sf-filter-clear-all">Remove Filters</a>');
        } else {
          jQ('.boost-pfs-clear-button-mobile').empty();
        }
        jQ('.boost-pfs-clear-button-mobile .bc-sf-filter-clear-all').on('click', function() {
          jQ('.boost-pfs-filter-clear-all').trigger('click');
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
        });
      
		if(Utils.isSearchPage()) {
          if(data.total_product > 0){
            var from = Globals.queryParams.page == 1 ? Globals.queryParams.page : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
            var to = from + data.products.length - 1;
            var totalProduct = data.total_product == 1 ? "Showing " + data.total_product + " result for '" + Globals.queryParams.q + "'" : "Showing " + data.total_product + " results for '" + Globals.queryParams.q + "'";  
            var totalProductSelector = jQ('.boost-pfs-filter-total-product');
            totalProductSelector.empty().html(totalProduct);
          }
        } else {
          if(data.total_product > 0){
            totalProductSelector.empty().html(totalProduct);
             var totalProductSelector2 = jQ('.bc-sf-filter-pagination-wrapper .boost-pfs-filter-total-product');
            if(data.total_product > boostPFSThemeConfig.custom.products_per_page) {
              totalProductSelector2.empty().html(totalProduct);
            } else {
              totalProductSelector2.empty();
            }
          }
          
          if(Utils.isMobile()){
    		var totalProduct = data.total_product !== 1 ? data.total_product + ' products' : data.total_product + ' product';  
    		var totalProductSelector = jQ('.CollectionInner__Products').find('.ProductListWrapper');
            jQ('#bc-sf-filter-number-styles').remove();
            if (jQ('.boost-pfs-filter-btn-load-previous-page-wrapper').length > 0) {
              jQ('.boost-pfs-filter-btn-load-previous-page-wrapper').after('<div id="bc-sf-filter-number-styles">' + totalProduct + '</div>');
            } else {
              totalProductSelector.prepend('<div id="bc-sf-filter-number-styles">' + totalProduct + '</div>');
            }
          }
        } 
      
      	if(Utils.isMobile()){
          if(to <= data.total_product && data.total_product > boostPFSThemeConfig.custom.products_per_page){
            if (jQ('.bc-custom-progress-bar .bc-custom-progress-bar-inner').length == 0){
              jQ('.bc-custom-progress-bar').append('<div class="bc-custom-progress-bar-inner"><div class="bc-custom-progress-bar-active"></div></div>');
            }

            var bcCustomProgressBarActive = (to/data.total_product) * 100 + '%';
            jQ('.bc-custom-progress-bar-active').css('width',bcCustomProgressBarActive);
          }else {
            jQ('.bc-custom-progress-bar').html("");
          }
        }
      
      	// BC - 57988
        var stickyElemet = '.bc-sf-filter-pagination-wrapper';
        var startElement = '#bc-sf-filter-bottom-pagination';
        var endElement = '#Search';
        if (Utils.isMobile()) {
          jQ(stickyElemet).stickTo(startElement, endElement);

          jQ('.CollectionToolbar__LayoutType').on('click', function(){
            setTimeout(function(){
              if (Utils.isMobile()) {jQ(stickyElemet).stickTo(startElement, endElement);}
            }, 1000)
          });
        }
      
      	if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges == 'function') {
          StampedFn.loadBadges();
        }
      
	};
  
    FilterLoadingIcon.prototype.getTemplate = function() {
		return '<div class="boost-pfs-filter-loading-custom" style="display: none;"><div class="loadlayerwrapper"><div class="loaderLayer"><span class="loader-64"></span><p>loading</p></div></div></div>';
	}
    
    ProductPaginationLoadMore.prototype.compileTemplate = function() {
		// Get HTML for pregress label
		var loadMoreProgress = this.compileTotalTemplate();
		if (!Globals.queryParams.page) {
			Globals.queryParams.page = 1;
		}
		var loadMoreNumber = this.totalProduct - Globals.queryParams.page * Globals.queryParams.limit;
		loadMoreNumber = Math.min(loadMoreNumber, Globals.queryParams.limit);
		
      	var totalPage = Math.ceil(this.totalProduct / Globals.queryParams.limit);
      
        if(Globals.queryParams.page < totalPage){
          if(this.totalProduct > 0){
          	return this.getTemplate()
              .replace(/{{loadMoreProgress}}/g, loadMoreProgress)
              .replace(/{{label.loadMore}}/g, Labels.loadMore)
              .replace(/{{class.productLoadMore}}/g, Class.productLoadMore)
              .replace(/{{ amountProduct }}/g, loadMoreNumber)
          }else{
          	return '';
          }
        }else{
          	/*
            var html = '<div id="bc-sf-filter-load-more-button-container">';
             html += '<h1 class="new-arrivals-title">In the mood to browse?</h1>';
             html += '<div class="storybar"><ul><li><a href="/collections/new-arrivals"><img id="69195a3f-359b-4fa7-9958-404b5d535822" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/NA_600x.jpg?v=1603869812"> New Arrivals</a></li><li><a href="/collections/best-sellers"><img id="1581690909276" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_42_600x.jpg?v=1599563007"> Best Sellers</a></li><li><a href="/collections/dresses"><img id="1581690982998" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_71_a5870646-a45a-455c-a19e-698a0b5ec2f2_600x.jpg?v=1605423950"> Dresses</a></li><li><a href="/collections/jumpsuits"><img id="1581691007915" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_66_cc621086-26d6-4606-b61b-db6a4d333cac_600x.jpg?v=1605424442"> Jumpsuits</a></li><li><a href="/collections/topwear"><img id="1581691027479" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_45_600x.jpg?v=1599563103"> Tops</a></li><li><a href="/collections/pants"><img id="1584101213849" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_70_600x.jpg?v=1605424519"> Pants</a></li><li><a href="/collections/skirts"><img id="1581691054210" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_47_600x.jpg?v=1599563117"> Skirts</a></li><li><a href="/collections/shorts"><img id="1581691074780" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_48_600x.jpg?v=1599563122"> Shorts</a></li><li><a href="/collections/outerwear"><img id="1581691103589" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_44_600x.jpg?v=1599563130"> Outerwear</a></li></ul></div>';
             html += '<a href="/collections/new-arrivals" class="new-arrivals Button Button--primary">Explore New Arrivals</a>';
             html += '</div>';
          	return html;
            */
          	return '';
        }
	}
    
    ProductPaginationLoadMore.prototype.render = function() {
		// Blank the default pagination
		this.$defaultElement.empty();
		var params = Globals.queryParams;
		// FIXME: Shouldn't use this.$loadMoreContainer to avoid duplication issue
		var loadMoreButtonHtml = this.compileTemplate();
		this.$element.html(loadMoreButtonHtml);
		if (jQ(Selector.loadMoreButtonContainer).length > 0) {
			var loadMoreProgress = this.compileTotalTemplate();
			jQ(this.selector.loadMoreTotal).replaceWith(loadMoreProgress);
		}
		this.$loadMoreContainer = jQ(Selector.loadMoreButtonContainer);

		// hide loading
		this.hideLoading();
		// Display Load more button if current page is smaller or equal to total number of pages
		var totalPage = Math.ceil(this.totalProduct / params.limit);
		var currentPage = parseInt(params.page);
		if (currentPage < totalPage && this.toProduct < this.totalProduct) {
			this.$element.show();
			this.$loadMoreContainer.show();
          	jQ('.bc-sf-filter-pagination-wrapper').show();
          	jQ('#bc-sf-filter-new-arrivals').hide();
		} else {
            this.$element.hide();
            jQ('.storybar').hide();
            jQ('.bc-sf-filter-pagination-wrapper').hide();
            var html = '<div id="bc-sf-filter-load-more-button-container">';
             html += '<h1 class="new-arrivals-title">In the mood to browse?</h1>';
             html += '<div class="storybar"><ul><li><a href="/collections/new-arrivals"><img id="69195a3f-359b-4fa7-9958-404b5d535822" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/NA_600x.jpg?v=1603869812"> New Arrivals</a></li><li><a href="/collections/best-sellers"><img id="1581690909276" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_42_600x.jpg?v=1599563007"> Best Sellers</a></li><li><a href="/collections/dresses"><img id="1581690982998" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_71_a5870646-a45a-455c-a19e-698a0b5ec2f2_600x.jpg?v=1605423950"> Dresses</a></li><li><a href="/collections/jumpsuits"><img id="1581691007915" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_66_cc621086-26d6-4606-b61b-db6a4d333cac_600x.jpg?v=1605424442"> Jumpsuits</a></li><li><a href="/collections/topwear"><img id="1581691027479" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_45_600x.jpg?v=1599563103"> Tops</a></li><li><a href="/collections/pants"><img id="1584101213849" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_70_600x.jpg?v=1605424519"> Pants</a></li><li><a href="/collections/skirts"><img id="1581691054210" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_47_600x.jpg?v=1599563117"> Skirts</a></li><li><a href="/collections/shorts"><img id="1581691074780" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_48_600x.jpg?v=1599563122"> Shorts</a></li><li><a href="/collections/outerwear"><img id="1581691103589" class="storynav" src="//cdn.shopify.com/s/files/1/0050/3264/0601/files/Frame_44_600x.jpg?v=1599563130"> Outerwear</a></li></ul></div>';
             html += '<a href="/collections/new-arrivals" class="new-arrivals Button Button--primary">Explore New Arrivals</a>';
             html += '</div>';
          	jQ('#bc-sf-filter-new-arrivals').html(html).show();
		}
	}
  
  	ProductPaginationLoadMore.prototype._onClickEvent = function(event) {
		event.preventDefault();
		// Hide button
		this.$loadMoreContainer.hide();
		// Show loading
		this.showLoading();
		// Next page
		this.nextPage++;
		// Build data of next page
		Globals.internalClick = true;
		// Set limit param
		FilterApi.setParam('limit', this.settings.limit);
		// Set new page param
		FilterApi.setParam('page', this.nextPage);
		if (Utils.FilterResult.isAdvancedPaginationType()) {
			// If the previous page feature is activated
			if (Utils.isLoadPreviousPagePaginationType()) {
				// Save the previous page data
				window.sessionStorage.setItem(this.settings.sessionStorageCurrentNextPage, this.nextPage);
				window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 0);
			}
			// Apply filter with new navigation url
			FilterApi.applyFilter('page');
		} else {
			// Apply filter without new navigation url
			var filter = BoostPFS.instance.filter;
			FilterApi.getFilterData('page', filter.setData.bind(filter));
		}
      
      	if (Utils.isMobile() && jQ('.bc-sf-filter-pagination-wrapper.bc-sf-filter-stick').length > 0) {
          window.scrollTo({
              top: (jQ('#bc-sf-filter-bottom-pagination').offset().top - 150),
              behavior: 'smooth'
          });
        }
	}
    
    jQ.fn.stickTo = function(startElement, endElement) {
        var _this = this;

        var startPos = jQ(startElement).offset().top + 150;
        var endPos = jQ(endElement).offset().top;

        var width = jQ(this).width();
        var setPosition = function() {
            var scrollToTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
            if (scrollToTop < (startPos)) { // Initial Position
                _this.removeClass('bc-sf-filter-stick');
                _this.css({ 
                    position: 'initial',
                    width: 'auto' 
                });
            } else { // Fixed Position
                _this.addClass('bc-sf-filter-stick');
                _this.css({
                    "position": 'fixed',
                    "top": '82px',
                    "width": width,
                    "z-index": "10"             
                });
            }
        };
        jQ(window).resize(function() {
            endPos = jQ(endElement).offset().top;
            setPosition();
        });
        jQ(window).scroll(setPosition);
        setPosition();
    };
  	FilterTree.prototype.getHeaderTemplate = function() {
		return `
			<div class="boost-pfs-filter-mobile-toolbar">
				<div class="boost-pfs-filter-mobile-toolbar-top">
					<span class="boost-pfs-filter-mobile-toolbar-top-overlay"></span>
				</div>
				<div class="boost-pfs-filter-mobile-toolbar-header">
					<span>{{label.refineMobile}}</span>
					<a href="javascript:;" class="{{class.closeFilterButton}}"><span>{{label.close}}</span></a>
				</div>
				<div class="boost-pfs-filter-mobile-toolbar-bottom">
					{{clearButton}}
				</div>
			</div>
		`.trim();
	}
    var originalBindEvents = FilterTree.prototype.bindEvents;
    FilterTree.prototype.bindEvents = function() {
      	originalBindEvents.call(this);
		
		// Close filter event when click overlay
		if (jQ('.boost-pfs-filter-mobile-toolbar-top-overlay').length > 0) {
			jQ('.boost-pfs-filter-mobile-toolbar-top-overlay').off('click').on('click', this.onCloseFilterTree.bind(this));
		}
	}
    FilterTreeStyle3.prototype.mathHeightToolbarHeader = function() {
		var heightToolbarMobile = jQ('.boost-pfs-filter-mobile-toolbar').height();
      	var heightRefineByMobile = jQ('.boost-pfs-filter-refine-by-wrapper').height();
		if (this.filterTreeType == FilterTreeEnum.FilterTreeType.VERTICAL && Utils.isMobile()) {
			jQ('.boost-pfs-filter-options-wrapper').css('top', heightToolbarMobile + heightRefineByMobile + 'px');
		}
	}
    /* end-boost-custom */


  // Build additional elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    document.addEventListener('theme:loading:end', function() {
                  console.log('loading end');
                });

    // Set Position Config
    // jQ('.boost-pfs-filter-products .boost-pfs__product-item').on('click', function name(params) {
    //   setConfig('dataPosition', {'id': jQ(this).data('product-id'), 'collection_id':boostPFSConfig.general.collection_id})
    // })
    
  
    // if (!Utils.isiOS()) {
    //   setTimeout(function (params) {
    //     scrollBack(eventType, config.dataPosition);
    //   }, 1000)
    // } 
  };

	ProductList.prototype._scrollBackToItem = function(scrollData) {
        console.log('_scrollBackToItem');
        console.log(scrollData);
		// Scroll back to item
		if (
			scrollData 
			&& scrollData.hasOwnProperty('page') 
			&& scrollData.hasOwnProperty('productId') 
			&& scrollData.hasOwnProperty('position') 
			&& scrollData.hasOwnProperty('url')
		) {
			// Check if the current url is the same with scroll data url
			var cloneQueryParams = JSON.parse(JSON.stringify(Globals.queryParams));
			var scrollUrlQueryString = typeof scrollData.url == 'string' && scrollData.url.split('?').length == 2 ? scrollData.url.split('?')[1] : '';
			const urlParams = new URLSearchParams(scrollUrlQueryString);
			var page = urlParams.get('page');
			if (page) {
				cloneQueryParams.page = page;
			}

			var url = Navigation.buildAddressBarUrl(cloneQueryParams);
			var paginationType = Settings.getSettingValue('general.paginationType');
			var $selectedProduct = this.$element.find('[data-id="' + scrollData.productId + '"]').first();
			var self = this;

			if (!$selectedProduct.length || url != scrollData.url) {
				self.parent._changeProductListGobackPreviousPositionStatus(false);
				return;
			}

			// Default pagination or first page: scroll to position
			if (paginationType == ProductPagination.Type.DEFAULT) {
                jQ( document ).ready(function() {
                  setTimeout(() => {
                    window.scrollTo({
    					top: scrollData.position,
    					behavior: 'smooth'
    				});
                  }, "500");
                });
			// Infinite, load more: scroll to product
			} else {
				// Get the selected product element
				var $selectedProduct = this.$element.find('[data-id="' + scrollData.productId + '"]').first();
                //var toolbarTop = jQ('.CollectionToolbar').offset().top;
  				var scrollPos = $selectedProduct.offset().top - scrollData.offset;
                console.log(scrollPos);
                // jQ( document ).ready(function() {
                  // setTimeout(() => {
                    window.scrollTo({
    					top: scrollPos,
    					behavior: 'smooth'
    				});
                  // }, 0);
                    
                // });
        document.addEventListener('animationend',()=>{
					console.log('kane-click')
				})
				

				if (window.IntersectionObserver) {
					var intersectionObserver = new IntersectionObserver(function (entries, observer) {
						for (var entry of entries) {
							if (entry.isIntersecting) {
								self.parent._changeProductListGobackPreviousPositionStatus(false);
								observer.disconnect();
							}
						}
					});

					intersectionObserver.observe($selectedProduct[0]);
				} else {
					setTimeout(() => {
						self.parent._changeProductListGobackPreviousPositionStatus(false);
					}, 500);
				}
			}
		}
	}

  // Add custom scroll back to position
  // var POSITION_STORAGE_KEY = {};
  // var config = JSON.parse(localStorage.getItem(POSITION_STORAGE_KEY)) || {};
  // function setConfig(key, value) {
  //     config[key] = value;
  //     localStorage.setItem(POSITION_STORAGE_KEY, JSON.stringify(config));
  // }
  // function scrollBack(eventType, dataConfig) {
  //   if (eventType == 'init' || eventType == 'history') {
  //     var isTrue = typeof dataConfig !== 'undefined' && typeof dataConfig.collection_id !== 'undefined' && dataConfig.collection_id === boostPFSConfig.general.collection_id && typeof dataConfig.id !== 'undefined';
  //     if(isTrue) {
  //       var element = document.querySelector('.boost-pfs-filter-products .boost-pfs__product-item[data-product-id="'+ dataConfig.id +'"]');
  //       if(element) {
  //         var rect = element.getBoundingClientRect();
  //         var scrollPos = rect.top;
  //         var offset = (rect.bottom - rect.top) / 2;
  //         if(Utils.isMobile()) {offset = -200};
  //         if (window.innerWidth <= 1100 && window.innerWidth > 767) {
  //           offset = -300;
  //         }
  //         if (window.innerWidth <= 1300 && window.innerWidth > 1100) {
  //           offset = -200;
  //         }
  //         if (window.innerWidth <= 1600 && window.innerWidth > 1300) {
  //           offset = -100;
  //         }
  //         if (window.innerWidth > 1600) {
  //           offset = -50;
  //         }
  //         window.scrollTo({
  //             top: scrollPos + offset,
  //             behavior: 'smooth'
  //         });
  //       }
  //     }
  //   }
  // }
})();